export default __webpack_public_path__ + "static/media/android-icon.993e4cc4.webp";